export const SHIELDS = {
  family: {
    title: "Family Pillar",
    imgsrc: "family.jpg",
    details:
      " Family Wellness means setting a good example through healthy behavior that creates a safe, stable environment for children, devoting time to family to ensure active participation in the household and putting family first by being flexible and seeking compromise when conflict arises.",
    listheader: "Benefits of developing strong family bonds include:",
    list: [
      "Children who are less likely to develop behavioral or emotional issues",
      "A family better prepared to weather and survive changes",
      "A reduction in stress and anxiety related to disagreements or arguments"
    ]
  },
  emotional: {
    title: "Emotional Pillar",
    imgsrc: "emotional.jpg",
    details:
      "Emotional Wellness includes emotional self-awareness and an acceptance of one’s emotional reactions in a way that helps an individual make positive choices and foster positive relationships.",
    listheader: "Investing in emotional wellness provides:",
    list: [
      "The ability to maintain emotional equanimity during stressful situations and bounce back when emotions take a negative turn",
      "Effective coping mechanisms for stress and anxiety",
      "Tools to ensure emotional reactions match the circumstances that trigger them",
      "Acceptance of feeling emotions without guilt or shame",
      "Effective problem-solving skills"
    ]
  },
  social: {
    title: "Social Pillar",
    imgsrc: "social.jpg",
    details:
      "Social Wellness involves performing social roles according to the needs of family, employers and community, connecting with others in a personal way and knowing how to recognize and cope with unhealthy relationships.",
    listheader: " Social Wellness helps individuals:",
    list: [
      "Develop healthy relationships that provide positive influence on the lives of those involved",
      "Develop healthy attachments characterized by mutual respect and an equal give and take",
      "Recognize when a relationship is harmful to them and understand how to leave it"
    ]
  },
  physical: {
    title: "Physical Pillar",
    imgsrc: "physical.jpg",
    details:
      "Physical Wellness includes taking care of oneself and maintaining good health.",
    listheader: "The benefits of attending to one’s Physical Wellness include:",
    list: [
      "Clear thinking",
      "Higher energy levels",
      "Increased ability to fight off sickness",
      "Improved flexibility, agility and cardiovascular health"
    ]
  },
  spiritual: {
    title: "Spiritual Pillar",
    imgsrc: "spiritual.jpg",
    details:
      "Spiritual Wellness means having personal values and beliefs and acting compassionately in accordance with those values.",
    listheader:
      "Individuals who develop Spiritual Wellness often find that they:",
    list: [
      "Are in touch with their potential to create and affect change",
      "Proliferate good things into the world like love, compassion and peace",
      "Have a deepened sense of morale and unity",
      "Have actions and intentions that align agreeably with the environment to the benefit of all within it",
      "Have expanded perspective that inspires acts of kindness, compassion, tolerance and altruism"
    ]
  }
};
